import React from 'react';
import Title from './Title';
import Grid from '@material-ui/core/Grid';
import HidaImage from '../../../images/features/hida/hida-city.png';
import HidaTourismImage from '../../../images/features/hida/hida-tourism-association.png';
import { makeStyles } from '@material-ui/core/styles';
import ContactGrid from '../ContactGrid';

const useStyles = makeStyles((theme) => ({
  grid: {
    margin: '2em 0',
    width: '100%',
  },
  logo: {
    width: '100%',
    maxWidth: 150,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
    },
  },
}));

const Partner = () => {
  const classes = useStyles();
  return (
    <div>
      <Title text="PARTNER" dense>
        連携パートナー
      </Title>
      <Grid
        container
        spacing={3}
        justify="center"
        alignItems="center"
        className={classes.grid}
      >
        <Grid item xs={6} sm="auto">
          <img src={HidaImage} className={classes.logo} />
        </Grid>
        <Grid item xs={6} sm="auto">
          <img src={HidaTourismImage} className={classes.logo} />
        </Grid>
      </Grid>
      <ContactGrid>
        他にも連携希望の市町村募集しております！人手不足等の困り事をキッカケに、一緒に関係人口を創出しましょう。ご希望の方はこちらのフォームからお気軽にお問い合わせください。
      </ContactGrid>
    </div>
  );
};

export default Partner;
